import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Transactions.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import axios from 'axios';
import {token, domain} from './../Security';
import {CreateTableForEmployeeSelect} from './../ManageTable';
import loadingSpinner from './../../assets/loading.gif';
import {useTable} from 'react-table';
import {globalTimeFormat} from './../Security';
// icon
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UploadIcon from '@mui/icons-material/Upload';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import SaveIcon from '@mui/icons-material/Save';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ListIcon from '@mui/icons-material/List';

function OfficialBusiness({user, userAccess, isHideSideMenu}) {
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [employee, setEmployee] = useState(user.employeePersonalInformationFullName);
    const [employeeId, setEmployeeId] = useState(user.employeePersonalInformationId);
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [timeFrom, setTimeFrom] = useState("");
    const [timeTo, setTimeTo] = useState("");
    const [location, setLocation] = useState("");
    const [reason, setReason] = useState("");
    const [files, setFiles] = useState([]);
    const [gpsCam, setGPSCam] = useState([]);

    const [showVieHistoryForm, setShowVieHistoryForm] = useState(false);

    const [showUploadForm, setShowUploadForm] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const apiUrl =  domain + "/api/OfficialBusinessRequest";

    const handleSubmit = async (event) => {
        event.preventDefault();

        const getFormattedDate = () => {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}T00:00`;
            return formattedDate;
        };

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        let base64String = "";
        let photoToBeSave = "";
    
        if(files.length > 0){
            base64String = await toBase64(files[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const uploadImage = files ? photoToBeSave : null;

        //GPS CAM
        let base64StringGPSCam = "";
        let photoToBeSaveGPSCam = "";
    
        if(gpsCam.length > 0){
            base64StringGPSCam = await toBase64(gpsCam[0]);
            photoToBeSaveGPSCam = base64StringGPSCam.split(',')[1];
        }

        const _gpsCam = gpsCam ? photoToBeSaveGPSCam : null;

        const data = {
            employeePersonalInformationId: employeeId,
            approverId: null,
            requestTypeId: 6, // 3 is Change Log Request
            reason: reason,
            reasonForRejection: null,
            status: "Sent",
            dateRequested: getFormattedDate(),
            dateCompleted: getFormattedDate(),
            content: uploadImage,
            gpsCam: _gpsCam,
            dateFrom: dateFrom,
            dateTo: dateTo,
            timeFrom: `${dateFrom}T${timeFrom}`,
            timeTo: `${dateTo}T${timeTo}`,
            location: location,
        };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoadingRequest(true);
            const response = await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            // await sendSms(response.data);
            await createApproval(response.data)

            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Data added successfully');

            // Reload table data and reset form fields
            setDateFrom("");
            setDateTo("");
            setTimeFrom("");
            setTimeTo("");
            setLocation("");
            setReason("");
            setFiles("");
            setGPSCam("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const createApproval = async (dataToAdd) => {
        const apiUrl =  domain + "/api/Approval";

        const data = {
            requestId: dataToAdd.id,
            requestTypeId: dataToAdd.requestTypeId,
            primaryApproverId: null,
            primaryApproverUpdateDate: null,
            primaryApproverStatus: "Pending",
            secondaryApproverId: null,
            secondaryApproverUpdateDate: null,
            secondaryApproverStatus: "Pending",
            tertiaryApproverId: null,
            tertiaryApproverUpdateDate: null,
            tertiaryApproverStatus: "Pending",
        };

        try {
            await axios.post(apiUrl + `/${0}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log("create approval success")
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }
    const closeUploadFormHandleClick = () => {
        setShowUploadForm(false);
    }
    const handleFileUpload = () => {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("This is undermaintenance");
    }

    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!employee || 
            !dateFrom ||
            !dateTo ||
            !timeFrom ||
            !timeTo || 
            !location
            ) {
            setErrorState(true);
            return;
        }

        if(files.length === 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Attached proof of approval is required.");

            return;
        }

        handleSubmit(e);

        setErrorState(false);
    };

    const openViewHistoryForm = () => {
        setShowVieHistoryForm(true);
    }
    const closeViewHistoryForm = () => {
        setShowVieHistoryForm(false);
    }

    // for upload
    const handleBrowse = async (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };

    const handleDrop = async (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        setFiles(fileList);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };

    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };

    const clearFiles = () => {
        setFiles([]);
        document.getElementById("fileInput").value = "";
    };

    // for upload gps cam
    const handleBrowseGPSCam = (e) => {
        const fileList = Array.from(e.target.files);

        setGPSCam(fileList);
    };
    const handleDropGPSCam = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        setGPSCam(fileList);
    };
    const handleDragOverGPSCam = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOutGPSCam = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFilesGPSCam = () => {
        // Clear the files state
        setGPSCam([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };

    //send sms
//     const fetchDataApproverById = useCallback(async () => {
//         const apiUrl =  domain + "/api/ApproverHierarchy";

//         try {
//             const response = await axios.get(apiUrl + `/${user.employeePersonalInformationId}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'application/json' // You can include other headers if needed
//             }})

//             return response.data;
//         } catch (error) {
//             console.error('Error fetching data:', error);
//             return [];
//         }
//     }, [user]);
//     const fetchDataEmployeesById = useCallback(async (id) => {
//         const apiUrl = domain +"/api/Employee";

//         try {
//             const response = await axios.get(apiUrl + `/${id}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'application/json'
//                 }
//             });

//             return response.data;
            
//         } catch (error) {
//             console.error('Error fetching data:', error);
//             return [];
//         }
//     }, []);
//     const sendSms = async (data) => {
//         const formattedNumber = data.referenceNumber.toString().padStart(6, '0');
//         const contacts = await getApproverContact();

//         if(contacts.length <= 0){
//             return;
//         }

// const composeMessage = 
// `Hello,

// ${employee} filed an DTR Correction Request. 

// Please check reference number CH-${formattedNumber} in the portal.`
// ;
        
//         for (const contact of contacts) {
//             const smsData = {
//                 requestTypeId: 4,
//                 date: new Date(),
//                 senderId: user.employeePersonalInformationId,
//                 senderFullName: user.employeePersonalInformationFullName,
//                 message: composeMessage,
//                 recipientId: contact.id,
//                 recipientFullName: contact.fullName,
//                 recipientMobileNumber: contact.phoneNumber // phoneNumber
//             }

//             try {
//                 const response = await axios.post('http://161.49.93.114:8081/api/Sms/send-sms', smsData); // euro asia
//                 // const response = await axios.post('http://192.168.10.157:8082/api/Sms/send-sms', smsData); // my server
//                 console.log(response, `SMS request sent to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`);
//             } catch (error) {
//                 console.error(`Error sending SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}:`, error);
//                 console.log(`Failed to send SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`);
//             }
//         }
//     };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                <div className="TransactionInfo Transaction-Form-Info shadow-xl">
                        <div className="transaction-header">
                        <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Official Business"}</span>
                        </div>
                        <div className='row' style={{alignItems:"center", justifyContent:"space-between"}}>
                            <h3>Official Business</h3>
                            <div className="transaction-form-upper row" style={{display: "none"}}>
                                {CreateButton("overtime-add-button", "upload row", (e)=>setShowUploadForm(true), "UPLOAD", UploadIcon)}
                                {CreateButton("overtime-add-button", "viewHistory row", openViewHistoryForm, "VIEW HISTORY", RemoveRedEyeIcon)}
                            </div>
                            <div className="transaction-form-upper row">
                                {CreateButton("overtime-add-button", "viewHistory row", openViewHistoryForm, "VIEW HISTORY", RemoveRedEyeIcon)}
                            </div>
                        </div>
                        </div>
                        <div className="transaction-body">
                            <div className="transaction-from-splitItem row">
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Employee</h4></div>
                                        <div className="transaction-form-input">
                                            <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                                <input
                                                    readOnly
                                                    className='employeeInput-select'
                                                    placeholder="Employee"
                                                    value={employee ? (employee) : employee}
                                                />
                                                <button className="select row"
                                                        onClick={()=>setShowEmployeeForm(true)}
                                                        style={{visibility: 
                                                            userAccess.description === "Admin" 
                                                            || userAccess.description === "HR Head" 
                                                            || userAccess.description === "HR Assistant" 
                                                            || userAccess.description === "HR Assistant2" 
                                                            || userAccess.description === "HR Assistant3" 
                                                            || userAccess.description === "HR Manager" 
                                                            ? "visible" : "hidden"}}
                                                ><SearchIcon/></button>
                                            </div>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !employee && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Location</h4></div>
                                        <div className="transaction-form-input">
                                            <input
                                                type='text'
                                                id="days"
                                                placeholder=""
                                                value={location}
                                                onChange={(e) => setLocation(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !location && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="transaction-from-splitItem row">
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Date From</h4></div>
                                        <div className="transaction-form-input">
                                            <DateInput date={dateFrom} setDate={setDateFrom}/>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !dateFrom && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Date From</h4></div>
                                        <div className="transaction-form-input">
                                            <DateInput date={dateTo} setDate={setDateTo}/>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !dateTo && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="transaction-from-splitItem row">
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Time From</h4></div>
                                        <div className="transaction-form-input">
                                            <TimeInput date={timeFrom} setDate={setTimeFrom}/>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !timeFrom && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Time To</h4></div>
                                        <div className="transaction-form-input">
                                            <TimeInput date={timeTo} setDate={setTimeTo}/>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !timeTo && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="transaction-form-item row" style={{paddingTop:"50px", alignItems:"revert"}}>
                                    <div className="transaction-form-category"><h4>Reason</h4></div>
                                    <div className="transaction-form-input">
                                        <textarea id="dtrCorrection-tamper"
                                            style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                            value={reason}
                                            onChange={(e) => setReason(e.target.value)}
                                        />
                                    </div>
                            </div>
                            <div className="transaction-form-item row" style={{paddingTop:"50px", alignItems:"revert"}}>
                                <div className="transaction-form-category"><h4>Attached Proof of Approval</h4></div>
                                <div className="transaction-form-input">
                                    <label htmlFor="fileInput" className='browse'>Browse...</label>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        onChange={(e)=> handleBrowse(e)}
                                        style={{ display: 'none' }}
                                    />
                                    
                                    {files.length > 0 ? (
                                        <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                            <span>Uploaded File:</span>
                                            <ul>
                                                {files.map((file, index) => (
                                                <span key={index}>{file.name}</span>
                                                ))}
                                            </ul>
                                            <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                                <button id="add-family" 
                                                className="cancel row"
                                                onClick={()=>clearFiles()}
                                                style={{marginRight:"5px"}}>
                                                    CLEAR
                                                </button>
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div
                                            id='drop-files-here'
                                            onDrop={(e)=>handleDrop(e)}
                                            onDragOver={(e)=>handleDragOver(e)}
                                            onDragLeave={(e)=>handleDragOut(e)}
                                            style={{
                                            border: '2px dashed #ccc',
                                            borderRadius: '5px',
                                            padding: '20px',
                                            marginTop: '10px',
                                            textAlign: 'center',
                                            }}
                                        >
                                            Drop files here
                                        </div>
                                    )
                                }
                                </div>
                            </div>
                            <div className="transaction-form-item row" style={{paddingTop:"50px", alignItems:"revert"}}>
                                <div className="transaction-form-category"><h4 style={{margin:'0'}}>GPS Cam Attachment</h4></div>
                                <div className="transaction-form-input">
                                    <label htmlFor="fileInputGPSCam" className='browse'>Browse...</label>
                                    <input
                                        type="file"
                                        id="fileInputGPSCam"
                                        onChange={(e)=> handleBrowseGPSCam(e)}
                                        style={{ display: 'none' }}
                                    />
                                    
                                    {gpsCam.length > 0 ? (
                                        <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                            <span>Uploaded File:</span>
                                            <ul>
                                                {gpsCam.map((file, index) => (
                                                <span key={index}>{file.name}</span>
                                                ))}
                                            </ul>
                                            <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                                <button id="add-family" 
                                                className="cancel row"
                                                onClick={()=>clearFilesGPSCam()}
                                                style={{marginRight:"5px"}}>
                                                    CLEAR
                                                </button>
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div
                                            id='drop-files-here'
                                            onDrop={(e)=>handleDropGPSCam(e)}
                                            onDragOver={(e)=>handleDragOverGPSCam(e)}
                                            onDragLeave={(e)=>handleDragOutGPSCam(e)}
                                            style={{
                                            border: '2px dashed #ccc',
                                            borderRadius: '5px',
                                            padding: '20px',
                                            marginTop: '10px',
                                            textAlign: 'center',
                                            }}
                                        >
                                            Drop files here
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="transaction-form-footer">
                                {CreateButton("dtrCorrection-add-button", "submit", (e)=>submit(e), "SEND REQUEST", "")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    handleFileUpload={handleFileUpload}
            >
            </UploadForm>
            <ViewHistoryForm  isOpen={showVieHistoryForm} 
                    onClose={closeViewHistoryForm}
                    user={user}
            >
            </ViewHistoryForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeeId}
                    setEmployee={setEmployee}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function DateInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={date.slice(0, 16)} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function TimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="time"
            id={"time"}
            name="datetime"
            value={date.slice(0, 16)} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function UploadForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function ViewHistoryForm({isOpen, 
    onClose,
    user
}){
    var header = [
        "Reference No.",
        "Location",
        "Date From",
        "Date To",
        "Time From",
        "Time To",
        "Reason",
        "Proof of Approval",
        "GPS Cam",
        "Status",
    ]
    var accessor = [
        "referenceNumber",
        "location",
        "dateFrom",
        "dateTo",
        "timeFrom",
        "timeTo",
        "reason",
        "content",
        "gpsCam",
        "status",
    ]

    const [loading, setLoading] = useState(false);
    const [requests, setRequests] = useState(false);
    
    const [showItineraryData, setShowItineraryData] = useState(false);
    const [selectedItinerary, setSelectedItinerary] = useState([]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/OfficialBusiness";

        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}/employee/${user.employeePersonalInformationId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            setRequests(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [user]);

    useEffect(() => {
        if(isOpen){
            fetchData();
        }
    }, [fetchData, isOpen]);

    const handleClose = () => {
        onClose();
    };
    
    const openItinerary = (data) =>{
        console.log(data)
        setSelectedItinerary(data.changeLogItineraries);
        setShowItineraryData(true);
    }
    const closeItinerary = () =>{
        setSelectedItinerary([]);
        setShowItineraryData(false);
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>DTR Correction Filed History</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTable
                                dataList={requests ? requests : []}
                                dataHeader={header}
                                dataAccessor={accessor}
                                openItinerary={openItinerary}
                            />
                            {requests.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
            <ViewItineraryForm  isOpen={showItineraryData} 
                    onClose={closeItinerary}
                    data={selectedItinerary}
            >
            </ViewItineraryForm>
        </>
    );
}
function ViewItineraryForm({isOpen, 
    onClose,
    data
}){
    var header = [
        "Time In",
        "Time Out",
        "Location",
    ]
    var accessor = [
        "timeIn",
        "timeOut",
        "location",
    ]

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Itinerary</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTable
                                dataList={data}
                                dataHeader={header}
                                dataAccessor={accessor}
                            />
                            {data && data.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}> {/*<p>No records to display</p>*/}</div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export function CreateTable({ dataList = [], 
    setDataList,
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    deleteHandleClick, 
    isItinerayAddState,
    setIsItinerayAddState,
    isItinerayUpdateState,
    setIsItinerayUpdateState,
    isItinerayDeleteState,
    setIsItinerayDeleteState,
    itineraryTimeIn,
    setItineraryTimeIn,
    itineraryTimeOut,
    setItineraryTimeOut,
    itineraryLocation,
    setItineraryLocation,
    locationData,
    openItinerary
}) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [idCounter, setIdCounter] = useState(0);
    const [recoveredData, setRecoveredData] = useState([]);

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data: dataList });

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const newData = {
        id: idCounter + 1,
        itineraryTimeIn: itineraryTimeIn,
        itineraryTimeOut: itineraryTimeOut,
        itineraryLocation: itineraryLocation,
    }

    const saveAdd = () =>{
        setIdCounter(idCounter + 1);
        setIsItinerayAddState(false);
        setIsItinerayUpdateState(false);
        setDataList(prevDataList => [
            ...prevDataList, 
            newData
        ]);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");
    }

    const cancelAdd = () =>{
        setIsItinerayAddState(false);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");
    }

    const updateClick = (data) =>{
        setRecoveredData(data);
        setItineraryTimeIn(data.itineraryTimeIn);
        setItineraryTimeOut(data.itineraryTimeOut);
        setItineraryLocation(data.itineraryLocation);
        const foundData = dataList.find(_data => _data.id === data.id);

        setDataList(prevDataList => 
            prevDataList.filter(_data => _data.id !== foundData.id)
        );

        setIsItinerayUpdateState(true);
    }
    const cancelUpdate = () =>{
        setIdCounter(idCounter + 1);

        const oldData = {
            id: recoveredData.id,
            itineraryTimeIn: recoveredData.itineraryTimeIn,
            itineraryTimeOut: recoveredData.itineraryTimeOut,
            itineraryLocation: recoveredData.itineraryLocation,
        }

        setDataList(prevDataList => [
            ...prevDataList, 
            oldData
        ]);

        setItineraryTimeIn("");
        setItineraryTimeOut("");
        setItineraryLocation("");

        setIsItinerayUpdateState(false);
    }
    const deleteClick = (data) =>{
        const foundData = dataList.find(_data => _data.id === data.id);

        setDataList(prevDataList => 
            prevDataList.filter(_data => _data.id !== foundData.id)
        );
    }

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {
                                    column.render("Header")
                                    }
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {isItinerayAddState ?
                        <tr>
                            <td>
                                <TimeInput date={itineraryTimeIn} setDate={setItineraryTimeIn}/>
                            </td>
                            <td>
                                <TimeInput date={itineraryTimeOut} setDate={setItineraryTimeOut}/>
                            </td>
                            <td>
                                <input
                                    placeholder="Enter location"
                                    value={itineraryLocation}
                                    onChange={(e) => setItineraryLocation(e.target.value)}
                                    style={{color: "gray",
                                        height: "30px",
                                        borderRadius: "3px",
                                        border: "1px solid #80808080",
                                        outline: "none",
                                        width: "90%"
                                    }}
                                />
                            </td>
                            <td>
                                <div className="row itinerary-manage"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <Tooltip text="Save">
                                        <div style={{padding:"0 5px"}} onClick={saveAdd}><SaveIcon/></div>
                                    </Tooltip>
                                    <Tooltip text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={cancelAdd}><DoDisturbIcon/></div>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                        :
                        <></>
                    }
                    {isItinerayUpdateState &&
                        <tr>
                            <td>
                                <TimeInput date={itineraryTimeIn} setDate={setItineraryTimeIn}/>
                            </td>
                            <td>
                                <TimeInput date={itineraryTimeOut} setDate={setItineraryTimeOut}/>
                            </td>
                            <td>
                                <input
                                    placeholder="Enter location"
                                    value={itineraryLocation}
                                    onChange={(e) => setItineraryLocation(e.target.value)}
                                    style={{color: "gray",
                                        height: "30px",
                                        borderRadius: "3px",
                                        border: "1px solid #80808080",
                                        outline: "none",
                                        width: "90%"
                                    }}
                                />
                            </td>
                            <td>
                                <div className="row itinerary-manage"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <Tooltip text="Save">
                                        <div style={{padding:"0 5px"}} onClick={saveAdd}><SaveIcon/></div>
                                    </Tooltip>
                                    <Tooltip text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={cancelUpdate}><DoDisturbIcon/></div>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            updateClick,
                                            deleteClick,
                                            locationData,
                                            openItinerary)
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick, locationData, openItinerary) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if (header === "Itinerary") {
        return(
            <td>
                <div className="itineary-control row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>openItinerary(data)}><ListIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }

    if(header === "Uploaded Image"){
        if(data.content){
            const imageSrc = 'data:image/jpeg;base64,' + data.content;

            return(
                <td>
                    <img className="" src={imageSrc} alt="" style={{width: "250px", height: "auto"}}/>
                </td>
            )
        }
        return(
            <td>
                <img className="" src="" alt=""/>
            </td>
        )
    }

    if( header === "Time In"
    || header === "Time Out"
    || header === "Time Rendered"
    ){
        const time = _cell.render("Cell").props.value;

        if (!time) {
            return (
                <td>
                    null
                </td>
            );
        }
    
        let formattedTime = '';
    
        // Attempt to parse the time if it’s not already in ISO format
        let date;
        if (time.includes('T')) {
            date = new Date(time);
        } else {
            // If the time is not in ISO format, manually create the date
            const currentDate = new Date(); // Get current date for the date portion
            const [hours, minutes] = time.split(':').map(part => parseInt(part, 10));
    
            if (isNaN(hours) || isNaN(minutes)) {
                return (
                    <td>
                        Invalid time format
                    </td>
                );
            }
    
            date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), hours, minutes);
        }
    
        if (isNaN(date.getTime())) {
            return (
                <td>
                    Invalid time format
                </td>
            );
        }
    
        // Convert to desired format YYYY-MM-DDTHH:mm
        // const year = date.getFullYear();
        // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        // const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
    
        // const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    
        // console.log(formattedDateTime); // Logs the converted time for debugging
    
        // Further formatting based on globalTimeFormat
        if (globalTimeFormat === "Standard Time") {
            const amPm = date.getHours() >= 12 ? 'PM' : 'AM';
            const standardHours = (date.getHours() % 12) || 12; // Convert 0 to 12 for 12-hour format
    
            formattedTime = `${standardHours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time") {
            formattedTime = `${hours}:${minutes}`;
        }
    
        return (
            <td>
                {formattedTime}
            </td>
        );
    }

    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default OfficialBusiness
